import { Component, OnInit } from '@angular/core';
import { faClipboard, faCalendarAlt, faChevronDown, faTimesCircle, faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { IconService } from './../../../services/icon.service';


@Component({
  selector: 'view-booking-base',
  template: ''
})
export class ViewBookingBaseComponent implements OnInit {

  faTimesCircle = faTimesCircle;
  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;
  faChevronDown = faChevronDown;
  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  faClipboard = faClipboard;
  faPlusCircle = faPlusCircle;


  constructor(
     iconService:IconService,
     domSanitizer: DomSanitizer,
     matIconRegistry: MatIconRegistry,) {

    // matIconRegistry.addSvgIcon(
    //   "carGearIcon",
    // domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );

    // matIconRegistry.addSvgIcon(
    //   "carDoorIcon",
    //   domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );

    matIconRegistry.addSvgIcon(
      "timeIcon",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );

    matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );

    matIconRegistry.addSvgIcon(
      "steeringWheel",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.steeringWheel)
    );
    matIconRegistry.addSvgIcon(
      "childSeats",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.childSeats)
    );
    matIconRegistry.addSvgIcon(
      "GPSNavigation",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.GPSNavigation)
    );
    matIconRegistry.addSvgIcon(
      "additionalService",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.additionalService)
    );
    matIconRegistry.addSvgIcon(
      "lateReturn",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.lateReturn)
    );
    matIconRegistry.addSvgIcon(
      "rentalContractExtension",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractExtension)
    );
    matIconRegistry.addSvgIcon(
      "rentalContractTermination",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractTermination)
    );
    matIconRegistry.addSvgIcon(
      "rentalReplacement",
      domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalReplacement)
    );
   }

  ngOnInit() {
  }

}
